import { render } from "./RemovableItem.vue?vue&type=template&id=1891aabd&scoped=true&ts=true"
import script from "./RemovableItem.vue?vue&type=script&lang=ts"
export * from "./RemovableItem.vue?vue&type=script&lang=ts"

import "./RemovableItem.vue?vue&type=style&index=0&id=1891aabd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1891aabd"]])

export default __exports__